import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH7Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH7 extends Component<KuikaH7Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h6 className={classNames("kuika-typography-h7", className)} {...props}>
        {children}
      </h6>
    );
  }
}

export default KuikaH7;
